<template>
  <div class="comment-box">
    <div v-show="state === 'default'">
      <div class="comment-profile">
        <div class="comment-avatar">
          <img :src="comment.user.profile_url" alt />
        </div>
        <div class="comment-user">{{comment.user.name}} {{comment.user.surname}} ({{comment.user.profiles[0].name}})</div>
      </div>
      <div class="comment-date">
        <span>{{comment.diff_date}}</span>
      </div>
      <div class="comment-text">
        <p>
          {{comment.content}}
          <a href="javascript:;" v-if="editable" @click="state = 'editing'">
            <i class="fa fa-edit"></i>
          </a>
        </p>
      </div>
    </div>
    <div v-show="state === 'editing'">
      <input v-model="data.content" placeholder="Update comment" />
      <div class="edit-comment-buttons">
        <div>
          <button class="update" @click="saveEdit">Update</button>
          <button class="delete" @click="deleteComment">Delete</button>
        </div>
        <button class="cancel" @click="resetEdit">Cancel</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    editable() {
      return this.user.id === this.comment.user.id;
    }
  },
  props: {
    comment: {
      required: true,
      type: Object
    },
    user: {
      required: true,
      type: Object
    }
  },
  data: function() {
    return {
      state: "default",
      data: {
        content: this.comment.content
      }
    };
  },

  methods: {
    resetEdit() {
      this.state = "default";
      this.data.content = this.comment.content;
    },
    saveEdit() {
      this.state = "default";
      this.$emit("comment-updated", {
        id: this.comment.id,
        content: this.data.content
      });
    },
    deleteComment() {
      this.$emit("comment-deleted", {
        id: this.comment.id
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/CommentItem.vue